// @flow
import { APICore } from './apiCore';
import config from '../../config';

const api = new APICore();

const BASE_URL = config.TRACKING_RECORDS_URL;

function processTrackingRecords(query: any): any {
    let baseUrl = `${BASE_URL}/process`;

    console.log('baseUrl', baseUrl);

    if (typeof query === 'string') {
        baseUrl += `?${query}`;
        return api.create(baseUrl, {});
    }

    return api.create(baseUrl, {}, { params: query || {} });
}

export { processTrackingRecords };
